import React, { useEffect } from "react";
import { useState } from "react";
import {
  Grid,
  Dialog,
  Typography,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { Actions } from "../../../../../components";

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
  customMessage?: string | null;
};

export const ConfirmationModal: React.FC<Props> = ({
  onCancel,
  onConfirm,
  open,
  customMessage
}) => {
  const [disableClick, setButtonState] = useState<boolean>(false);

  useEffect(() => {
    if (disableClick)
      setButtonState(!disableClick);
  }, [onConfirm]);

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onCancel}>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography>{(customMessage !== "" || customMessage !== null) ? customMessage : "Are you sure you want to submit request?"}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Actions>
              <Actions.Action outlined onClick={onCancel}>
                Cancel
              </Actions.Action>
              <Actions.Action onClick={() => {
                                                setButtonState(!disableClick);
                                                onConfirm();
                                             }}
                              disabled={disableClick}>
                Yes
              </Actions.Action>
            </Actions>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};
